import React from 'react';
import fm from 'front-matter';
import Handlebars from 'handlebars';
import showdown from 'showdown';
import { Markdown } from 'react-showdown';

export default class MarkdownArea extends React.Component {
    constructor(props) {
        super(props);
        showdown.setOption('tables', 'true');
        showdown.setOption('simpleLineBreaks', 'true');
    }

    createMarkup(data) {
        return { __html: data };
    }

    // to play around with this approach or to see some examples go to: https://github.com/adavidev/front-matter-mustache
    convert(text) {
        //front-matter
        var fmdata = fm(text);

        //handlebars
        Handlebars.registerHelper({
            ifBeforeAfter: function(dateString, endString, opts) {
                if (
                    new Date(dateString) <= new Date() &&
                    new Date(endString) >= new Date()
                ) {
                    return opts.fn(this);
                }
            },
        });
        var template = Handlebars.compile(fmdata.body);
        var rendered = template(fmdata.attributes);

        //showdown
        var converter = new showdown.Converter();
        var output = converter.makeHtml(rendered);

        return output;
    }

    render() {
        var text = this.props.children;

        const formattedHtml = this.convert(text);

        return (
            <div className="md-text">
                <Markdown
                    markup={formattedHtml}
                    components={
                        this.props.components
                            ? Object.assign(this.props.components, utilObjects)
                            : utilObjects
                    }
                />
            </div>
        );
    }
}

const Style = props => {
    return <style>{props.children}</style>;
};

const utilObjects = { Style };
